export function getNewContactFieldProps({
  contact,
  errors,
  name,
  submitCount,
  values,
}) {
  return {
    fieldError:
      contact.typeConfig.isPhone || submitCount === 0
        ? null
        : errors[contact.id]?.[name],
    fieldName: `${contact.id}.${name}`,
    isFieldError: submitCount > 0 && !values[contact.id][name],
  }
}
